import script from "./contentManageDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./contentManageDialog.vue?vue&type=script&setup=true&lang=ts"

import "./contentManageDialog.vue?vue&type=style&index=0&id=9d98158a&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d98158a"]])

export default __exports__